import { parseDate } from "@eusoft/webapp-ui/utils/Date";
import type { Guid, IServiceAccessToken } from "../entities/Commands";
import { executeAsync } from "./DataService";
import { nativeApp, type IBankPosPayment, type IBankPosPayResult } from "./NativePayment";


interface ISalePointInfo {
    bankPosId: Guid;
}
interface IServiceInfo {
    access: IServiceAccessToken;
    merchantId: Guid;
    providerName: string;
}

export interface IBankPosPayResultExtra extends IBankPosPayResult {
    amount: number;
    providerName: string;
}

class BankPosManager {

    _spMap = new Map<Guid, ISalePointInfo>();
    _serviceMap = new Map<Guid, IServiceInfo>();

    async initSalePointAsync(salePointId: Guid) {

        const view = (await executeAsync("ListSalePoint", { ids: [salePointId] }))?.items[0];

        this._spMap.set(salePointId, {
            bankPosId: view.activeBankPos?.id
        });

        if (view.activeBankPos?.id) {

            const service = (await executeAsync("ListMerchantServices", {
                ids: [view.activeBankPos.id],
                merchantId: view.merchant.id
            }))?.items[0];

            await this.refreshToken(service.id, view.merchant.id, service.providerName);

        }
    }

    async refreshToken(id: Guid, merchantId: Guid, providerName: string) {

        const access = await executeAsync("GetServiceAccessToken",
            {
                merchantId,
                serviceName: providerName
            });

        const res: IServiceInfo = {
            access,
            merchantId,
            providerName
        };

        this._serviceMap.set(id, res);

        nativeApp.bankPosConfigureAsync(res.providerName, {
            accessToken: res.access.accessToken
        })

        return res;
    }

    async tryPayPos(salePointId: Guid, payment: IBankPosPayment): Promise<"no-pos" | "success" | "pos-error" | IBankPosPayResultExtra> {

        try {

            const view = this._spMap.get(salePointId);

            if (!view?.bankPosId)
                return "no-pos";

            let service = this._serviceMap.get(view.bankPosId);

            if (service.access?.expireTime) {

                if (parseDate(service.access?.expireTime).getTime() < Date.now()) {

                    service = await this.refreshToken(view.bankPosId, service.merchantId, service.providerName);
                }
            }

            if (!service?.access?.accessToken)
                return "no-pos";

            const result = await nativeApp.bankPosPayAsync(service.providerName, payment);

            return {
                ...result,
                amount: payment?.amount,
                providerName: service.providerName
            } as IBankPosPayResultExtra
        }
        catch (ex) {

            console.error("tryPayPos", ex);
            return "pos-error";
        }
    }

}

export const bankPos = new BankPosManager();